export function ErrorState({
  message = "Si è verificato un errore nel caricamento dei dati. Riprova più tardi o contatta il supporto se il problema persiste.",
}: {
  message?: string;
}) {
  return (
    <p className={"text-sm text-red-600 bg-red-50 rounded p-3"}>{message}</p>
  );
}
